"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSIFY_WEBP_QUALITY = exports.CLASSIFY_JPEG_QUALITY = void 0;
exports.resolveClassifyImageMime = resolveClassifyImageMime;
exports.classifyImageQuality = classifyImageQuality;
exports.classifyImageFileName = classifyImageFileName;
exports.CLASSIFY_JPEG_QUALITY = 0.8;
exports.CLASSIFY_WEBP_QUALITY = 0.6;
/** WebP only when the encoder actually produced WebP. Everything else, including PNG, becomes JPEG. */
function resolveClassifyImageMime(encodedType) {
    return encodedType === 'image/webp' ? 'image/webp' : 'image/jpeg';
}
function classifyImageQuality(mime) {
    return mime === 'image/webp' ? exports.CLASSIFY_WEBP_QUALITY : exports.CLASSIFY_JPEG_QUALITY;
}
function classifyImageFileName(mime) {
    return mime === 'image/webp' ? 'image.webp' : 'image.jpg';
}
